export type CountryCentroid = {lat: number; lon: number};

export const COUNTRY_CENTROIDS: Record<string, CountryCentroid> = {
    AE: {lat: 23.4241, lon: 53.8478},
    BE: {lat: 50.5039, lon: 4.4699},
    DE: {lat: 51.1657, lon: 10.4515},
    DK: {lat: 56.2639, lon: 9.5018},
    CH: {lat: 46.8182, lon: 8.2275},
    ES: {lat: 40.4637, lon: -3.7492},
    FI: {lat: 61.9241, lon: 25.7482},
    FR: {lat: 46.2276, lon: 2.2137},
    GB: {lat: 55.3781, lon: -3.436},
    IT: {lat: 41.8719, lon: 12.5674},
    NL: {lat: 52.1326, lon: 5.2913},
    NO: {lat: 60.472, lon: 8.4689},
    PT: {lat: 39.3999, lon: -8.2245},
    QA: {lat: 25.3548, lon: 51.1839},
    SA: {lat: 23.8859, lon: 45.0792},
    SE: {lat: 60.1282, lon: 18.6435},
    AT: {lat: 47.5162, lon: 14.5501},
};

export function getCountryCentroid(countryCode?: string | null): CountryCentroid | null {
    if (!countryCode) {
        return null;
    }
    const code = countryCode.toUpperCase();
    return COUNTRY_CENTROIDS[code] ?? null;
}
